import { forwardRef, useRef, useState } from "react";
import CSS from "./styles.module.css";

/**
 * TextBox component by © MTTP://SignatureUI
 *
 * List of Props supported:
 *  - type (Choose various Input types)
 *  - variant (Choose one of the Variants of the component)
 *  - placeholder (Pass placeholder text as string)
 *  - leftActionArea (Clickable action area on the left side of the TextBox, pass icons/components)
 *  - rightActionArea (Clickable action area on the left side of the TextBox, pass icons/components)
 *  - leftIcon (Set true if an Icon is passed in the left area)
 *  - rightIcon (Set true if an Icon is passed in the right area)
 *  - className (Pass a custom className)
 *  - id (Pass id as string)
 *  - value (Pass TextBox's value)
 *  - defaultValue (Pass TextBox's default value)
 *  - inactive (pass true to inactive TextBox)
 *  - autoFocus (true/false)
 *  - onClick (onClick event handler)
 *  - onFocus (onFocus event handler)
 *  - onBlur (onBlur event handler)
 *  - onChange (onChange event handler)
 *  - onKeyUp (onKeyUp event handler)
 *  - onKeyDown (onKeyDown event handler)
 *  - wide (Make TextBox span 100%)
 *
 * @param {{
 * type: 'email' | 'number' | 'password' | 'search' | 'tel' | 'text' | 'url';
 * variant: 'Standard' | 'MessageTextBox' | 'PhoneNumberTextBox' | 'OTPTextBox' | 'Name';
 * placeholder: string;
 * leftActionArea: object;
 * leftIcon: boolean;
 * rightActionArea: object;
 * rightIcon: boolean;
 * className: string;
 * id: string;
 * value: string;
 * defaultValue: string;
 * inactive: boolean;
 * autoFocus: boolean;
 * onClick: object;
 * onFocus: object;
 * onBlur: object;
 * onChange: object;
 * onKeyUp: object;
 * onKeyDown: object;
 * optionalLabel: boolean;
 * requiredLabel: boolean;
 * wide: boolean
 * }}
 *
 */

export const SelectMenu = forwardRef(
	(
		{
			type,
			variant,
			className,
			placeholder,
			leftIcon,
			rightIcon,
			leftActionArea,
			rightActionArea,
			id,
			onKeyUp,
			onKeyDown,
			onClick,
			onChange,
			onBlur,
			onFocus,
			autoFocus,
			value,
			defaultValue,
			outputValue,
			inactive,
			optionalLabel,
			requiredLabel,
			wide,
			children,
		},
		ref
	) => {
		const [leftAA] = useState("inputLAA");
		const [rightAA] = useState("inputRAA");

		const [isActive, setIsActive] = useState(false);
		const textBox = useRef(null);

		const handleClick = (state) => {
			if (state) {
				setIsActive(true);
			} else {
				setIsActive(false);
			}
		};

		const valueSetter = (e) => {
			textBox.current.value = e.target.innerText;
			outputValue(textBox.current.value);
		};

		return (
			<div className={`${CSS.SelectMenuWrapper} ${className ? className : ""}`}>
				<div
					className={`${CSS.input} ${inactive ? CSS.inactive : ""} ${
						variant !== "Standard" && CSS[variant]
					} ${leftActionArea ? CSS[leftAA] : ""} ${
						rightActionArea ? CSS[rightAA] : ""
					} ${rightActionArea ? CSS.inactive : ""} ${wide ? CSS.wide : ""}`}
				>
					<input
						type={type ? type : "text"}
						autoComplete="nope"
						defaultValue={defaultValue}
						value={value}
						id={id}
						ref={textBox}
						onChange={() => console.log("Hello")}
						onClick={onClick}
						onKeyUp={onKeyUp}
						onKeyDown={onKeyDown}
						onFocus={() => handleClick("focus")}
						onBlur={() => handleClick()}
						required
						autoFocus={autoFocus ? true : false}
					/>
					<label>
						{placeholder ? placeholder : ""}
						{optionalLabel && <font className={CSS.opt}> (Optional)</font>}
						{requiredLabel && <font style={{ color: "var(--Red)" }}>*</font>}
					</label>
					{leftActionArea && (
						<div className={`${CSS.ActionArea} ${CSS.left}`}>
							{leftIcon ? (
								<span className="material-symbols-round">{leftActionArea}</span>
							) : (
								leftActionArea
							)}
						</div>
					)}
					<div className={`${CSS.ActionArea} ${CSS.right}`}>
						<span className="material-symbols-round">expand_more</span>
					</div>
				</div>
				<div
					className={`${CSS.SelectionBox} ${
						isActive && CSS.SelectionBoxActive
					}`}
				>
					<div className={CSS.Header}>
						{textBox && textBox.current && textBox.current.value}
					</div>
					{children.map((item, i) => (
						<div className={CSS.Actions} key={i} onMouseDown={valueSetter}>
							{item}
						</div>
					))}
				</div>
			</div>
		);
	}
);
